try{
    Typekit.load({ async: true });
}catch(e){
    console.log('failed to load typekit')
}